import { useRouter } from '@application/utils';
import { MtApplicationCheckoutFailedPage } from '@presentation/pages';

export const MtApplicationCheckoutFailedPageController = () => {
  const { routeLocationDescriptor } = useRouter();

  return (
    <MtApplicationCheckoutFailedPage applicationsLink={routeLocationDescriptor('mtApplications')} />
  );
};
